import React from "react";
import app from "../base";
import { useContext, useState} from "react";
import { AuthContext } from "../Auth.js";
import { withRouter } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel';
import "../App.css"
import "../css/bootstrap.css"
import "../css/styles.css"
import Logo from "../images/logo text.png" 
import Risk from "../images/riskEN.png"
import Search from "../images/searchEN.png"
import Food from "../images/FoodEN.png"
import Sleep from "../images/sleepEN.png"
import Bru from "../images/BruEN.png"
import Cadiac from "../images/cadiacEN.png"
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Poster3 from "../images/pos3EN.png"
import Poster10 from "../images/pos11.png"
import Poster15 from "../images/pos15EN.png"
import Poster18 from "../images/MobileEN.png"
import Poster2 from "../images/Poster2.png"

const Home = ({history}) => {
  const { currentUser } = useContext(AuthContext);
  var ReactRotatingText = require('react-rotating-text');

  const Signout = () => {
    app.auth().signOut();
    window.location.reload(true)
    
  };

  const Upload = () => {
    history.push("/upload");
    window.location.reload(true)
  }
  const login = () => {
    history.push("/Login");
    window.location.reload(true)
  }

  const btnstyle = {
    backgroundcolor: "black"
  };

 


  return (
    
    <>


<Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/en/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="#service">
              Service <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center>
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="#EIPCAnews">
              News from EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/about">
              About us
            </Nav.Link>
          </li>
        </center>
        
        
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >Sign out</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/en/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              TH |
            </Nav.Link>
          </li>
        </center>

        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/">
              EN
            </Nav.Link>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>



    
    
    
        
    
      
      
    <header id="header" className="header font-face-gm" backgroundcolor="Green">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 col-xl-5">
          
          {/* end of text-container */}
        </div>{" "}
        {/* end of div */}
        <center>
        <div className="col-lg-6 col-xl-7">
          <div className="image-container img-fluid">
                  <Carousel fade>
              <Carousel.Item>
                <img
                  className="d-block w-100 img7"
                  src={Poster3}
                  alt="First slide"
                />
                <Carousel.Caption>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 img7"
                  src={Poster18}
                  alt="Second slide"
                />
                <Carousel.Caption>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 img7"
                  src={Poster2}
                  alt="Third slide"
                />
                <Carousel.Caption>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
            {/* </div> end of image-container */}
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        <a  className="btn-solid-lg page-scroll mx-3 my-4" href="#service">Start using EIPCA</a>
        </center>
        {/* end of row */}
      </div>{" "}
      {/* end of container */}
    </div>
  </header>{" "}

  <div className="basic-5 ">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="image-container">
            <img
              className="img-fluid" style={{borderRadius: "10px"}}
              src={Poster10}
              alt="alternative"
            />
          </div>{" "}
          {/* end of image-container */}
        </div>{" "}
        {/* end of col */}
        
        <div className="col-lg-6">
          <div className="text-container">
            <h6 className="text-secondary text-uppercase font-weight-medium mb-3">
              
            </h6>
            <h1 className="" font-color="#ffffff" style={{fontSize: "65px"}}>
              {" "}
              EIPCA
            </h1>
            <h3 className="font-weight-high font-italic mb-3 " >
            WORLD'S FIRST
            <h3 className="font-weight-medium font-italic mb-3 " >
            Augmented Unipolar lead for Brugada syndrome detection.

            </h3>
            </h3>
            
            <p className="mb-2 font-face-gl">
             
            </p>
          </div>{" "}
          {/* end of text-container */}
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
    
  </div>{" "}
  {/* end of basic-5 */}


  <center>
  <div id="service" className="filter">
    <div className="basic-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* <h1 className="h2-heading">EIPCA</h1>
            <div className="header6" />  */}
            <br />
            <br />
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* end of row */}
        <div className="row">
          <div className="col-lg-12">
            {/* Job */}
            <div className="job-container">
              <a style={{textDecoration: "none"}} href="/en/choose">
              <img
                className="img6"
                src={Risk}
              />
              {/* <h2  className="my-2">
                เริ่มต้นการวัดความเสี่ยง
              </h2>
              <p>
                เข้าไปเพื่อเริ่มทำแบบประเมินความเสี่ยงการเกิดโรคหัวใจ และหลังจากนั้นท่านสามารถเลือกระบบของ EIPCA เพื่อเริ่มตรวจกราฟคลื่นไฟฟ้าหัวใจ{" "}
                
              </p> */}
              </a>
            </div>{" "}
            <div className="job-container " >
              <a style={{textDecoration: "none"}} href="/en/SuggestionHospital2">
              <img
                className="img6"
                src={Search}
              />
              
              
              </a>
            </div>{" "}
            {/* end of job-container */}
            {/* end of job */}
            {/* Job */}
            {/* <div className="job-container">
              <a style={{textDecoration: "none"}} href="/Hardware">
              <img
                className="img6"
                src= {Logo2}
              />
              <h2  className="my-2">อุปกรณ์</h2>
              <p>
              อุปกรณ์ประเมินความเสี่ยงการเกิดโรค Brugada
              อุปกรณ์นี้คืออุปกรณ์ตรวจวัดคลื่นไฟฟ้าหัวใจหรือจะเรียกอีกอย่างว่าเครื่อง
              ECG ขนาดพกพา
                
              </p>
              </a>
            </div>{" "} */}
            {/* end of job-container */}
            {/* end of job */}
            {/* Job */}
            {/* <div className="job-container">
              <a style={{textDecoration: "none"}} href="/HowtoUse">
              <img
                className="img6"
                src={Logo2}
              />
              
              </a>
            </div>{" "} */}
            {/* end of job-container */}
            {/* end of job */}
            {/* Job */}
           
            
            {/* end of job-container */}
            {/* end of job */}
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* end of row */}
      </div>{" "}
      {/* end of container */}
    </div>{" "}
    {/* end of basic-3 */}
  </div>

  </center>

  <div className="basic-4 bg">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="text-container">
            <h6 className="text-secondary text-uppercase font-weight-medium mb-3">
              Learn About Us
            </h6>
            <h1 className="" font-color="#ffffff">
              {" "}
              What is EIPCA?
            </h1>
            <h5 className="font-weight-medium font-italic mb-4">
              Electrocardiogram Interpretation Pattern for Symptom Predictions
              of Arrythmia.
            </h5>
            <p className="mb-2 font-face-gl">
            EIPCA is an AI-powered platform designed to aid in the rapid screening of arrhythmias, a condition characterized by irregular heart rhythms, using electrocardiogram waveforms. It aims to identify a group of symptoms, shorten diagnostic time, and address the shortage of healthcare professionals.{" "}
            </p>
          </div>{" "}
          <a  className="btn-solid-lg page-scroll mx-3 my-4" href="/en/about">Read more</a>
          {/* end of text-container */}
        </div>{" "}
        {/* end of col */}
        <div className="col-lg-6">
          <div className="image-container">
            <img
              className="img-fluid" style={{borderRadius: "10px" }}
              src={Poster15}
              alt="alternative"
            />
          </div>{" "}
          {/* end of image-container */}
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </div>{" "}
  {/* end of basic-4 */}    
  

  





  <center>
  <div id="EIPCAnews" className="filter">
    <div className="basic-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h1 className="h2-heading font-face-gm">News from EIPCA</h1>
            
            <br />
            <br />
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* end of row */}
        <div className="row">
          <div className="col-lg-12">
            {/* Job */}
            <div className="job-container " >
              <a style={{textDecoration: "none"}} href="/Data1">
              <img
                className="img6"
                src={Bru}
                />
              
              </a>
            </div>{" "}
            {/* end of job-container */}
            {/* end of job */}
            {/* Job */}
            <div className="job-container">
            <a style={{textDecoration: "none"}} href="/Data2">
              <img
                className="img6"
                src={Sleep}
              />
              
              </a>
            </div>{" "}
            {/* end of job-container */}
            {/* end of job */}
            {/* Job */}
            <div className="job-container">
            <a style={{textDecoration: "none"}} href="/Data3">
              <img
                className="img6"
                src={Cadiac}
              />
              
              </a>
            </div>{" "}
            {/* end of job-container */}
            {/* end of job */}
            {/* Job */}
            <div className="job-container">
            <a style={{textDecoration: "none"}} href="/Data4">
              <img
                className="img6"
                src={Food}
              />
              
              </a>
            </div>{" "}
            {/* end of job-container */}
            {/* end of job */}
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* end of row */}
      </div>{" "}
      {/* end of container */}
    </div>{" "}
    {/* end of basic-3 */}
  </div>
  </center>
  {/* end of job listing */}




{/* footer */}
<div className="footer bg-gray">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="footer-col first">
            <h6 className="font-face-gm">About EIPCA</h6>
            <p className="p-small font-face-gl">
            EIPCA stands for Electrocardiogram Interpretation Pattern for Symptom Predictions of Arrhythmia, a program aimed at assisting in the screening of sudden cardiac arrest (sudden death) caused by irregular heart rhythms through the analysis of electrocardiogram waveforms using artificial intelligence.
            </p>
          </div>{" "}
          {/* end of footer-col */}
          <div className="footer-col second font-face-gm">
            <h6 className="font-face-gm">Contact Us</h6>
            <ul className="list-unstyled li-space-lg p-small font-face-gl">
              <p>
                <i className="fa fa-map-marker-alt mr-2" />
                EIPCA Team 
              </p>
              <p>
                <i className="fa fa-phone-alt mr-2" />
                093-2789556 , 081-2895915 , 
              </p>
              <p>
                <i className="fa fa-phone-alt mr-2" />
                065-3595514
              </p>
              <p>
                <i className="fa fa-envelope mr-2" />
                EIPCAhackathon@gmail.com
              </p>
            </ul>
          </div>{" "}
          {/* end of footer-col */}
          <div className="footer-col third font-face-gm">
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-facebook-f fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-twitter fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-pinterest-p fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-instagram fa-stack-1x" />
              </a>
            </span>
            <p className="p-small">
              We would love to hear from you{" "}
              <a href="">
                <strong>EIPCAhackathon@gmail.com</strong>
              </a>
            </p>
          </div>{" "}
          {/* end of footer-col */}
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </div>{" "}
  {/* end of footer */}
 
 


      
    </>
  );
};

export default withRouter(Home);